export default __webpack_public_path__ + "static/media/0x3a58a54c066fdc0f2d55fc9c89f0415c92ebf3c4.03fa3053.webp";